export function normalizePhoneNumber(input, mode = 'local') {
  if (!input) return 0;

  const modes = { local: true, international: true };
  if (!modes[mode]) mode = 'local'; // fallback

  let raw = input.toString().trim();
  let plus = raw.startsWith('+');
  let num = raw.replace(/\D/g, '');

  // PH formats
  if (num.length === 12 && num.startsWith('63')) {
    if (mode === 'local') return '0' + num.slice(2); // 09XXXXXXXXX
    if (mode === 'international') return '+' + num; // +63XXXXXXXXXX
  }

  if (num.length === 11 && num.startsWith('09')) {
    if (mode === 'local') return num; // 09XXXXXXXXX
    if (mode === 'international') return '+63' + num.slice(1);
  }

  if (num.length === 10 && num.startsWith('9')) {
    if (mode === 'local') return '0' + num; // 09XXXXXXXXX
    if (mode === 'international') return '+63' + num;
  }

  // Already international
  if (plus && /^\+[1-9]\d{10,14}$/.test('+' + num)) {
    if (mode === 'international') return '+' + num;
    if (mode === 'local') {
      // Option: only handle PH (+63…), otherwise just strip the "+"
      return num.startsWith('63') ? '0' + num.slice(2) : num;
    }
  }

  return 0; // invalid
}
